// note - this is in a seperate file to urls.ts so that it can be easily mocked.
const getLocation = () => window.location;

export default getLocation;